import * as components from './components'

export default [
  {
    path: '/orders',
    component: components.Balance,
    name: 'balance'
  },
  {
    path: '/orders/order/:docId',
    component: components.RashodnayaNakladnaya,
    name: 'balance/rashodnayanakladnaya'
  },
  {
    path: '/orders/order_external/:docId',
    component: components.RashodnayaNakladnayaZakaz,
    name: 'balance/rashodnayanakladnaya_zakaz'
  },
  {
    path: '/orders/proposal/:docId',
    component: components.PrihodnayaNakladnaya,
    name: 'balance/prihodnayanakladnaya'
  },
  {
    path: '/orders/order_cancel/:docId',
    component: components.VozvratnayaNakladnaya,
    name: 'balance/vozvratnayanakladnaya'
  },
  {
    path: '/orders/order_cancel_external/:docId',
    component: components.VozvratnayaNakladnayaZakaz,
    name: 'balance/vozvratnayanakladnaya_zakaz'
  },
  {
    path: '/orders/proposal_external/:docId',
    component: components.ZakaznayaPrihodnaya,
    name: 'balance/zakaznayaprihodnaya'
  }
]
